export default "__VITE_ASSET__6958bc94__"